import { render, staticRenderFns } from "./TripResponseListItem.vue?vue&type=template&id=0b1c7048&scoped=true&"
import script from "./TripResponseListItem.vue?vue&type=script&lang=js&"
export * from "./TripResponseListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripResponseListItem.vue?vue&type=style&index=0&id=0b1c7048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c7048",
  null
  
)

export default component.exports